import React, { useState } from "react";
import GPBuyerApproved from "./Approved";
import GPBuyerUnapproved from "./Unapproved";
import MyOffers from "./MyOffers";
import GPBuyerMergingOffers from "./MerginOffers";

const GPBuyerOffersModule = () => {
  const [activeTab, setActiveTab] = useState("My Offers");

  const tabs = ["My Offers","Unapproved Offers", "Approved Offers"];
  const renderTabContent = () => {
    switch (activeTab) {
      case "Unapproved Offers":
        return <GPBuyerUnapproved />;
      case "Approved Offers":
        return <GPBuyerApproved />;
      case "My Offers":
        return <MyOffers />;
      //case "Merging Offers": return <GPBuyerMergingOffers/>;

      default:
        return <MyOffers />;
    }
  };

  return (
    <div className="buyer-layout">
      <div className="amtpl-tabs">
        <div className="content3">
          <main className="main-content">
            <div className="main-tab">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`buttonclass ${
                    activeTab === tab ? "active" : "notactive"
                  }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
            <div className="row">{renderTabContent()}</div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default GPBuyerOffersModule;
